import { TADManager } from "tad-core";
import { Shark, Utils } from "shark-mvc";
import "Models/Driver";

var driverManager = Shark.createJaw("driverManager");

driverManager.addMethod("logIn", function (driver) {
	TADManager.clearCollection();
	TADManager.createTAD({ t: "driver", a: "login", d: [driver.export("logIn")] });

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);
		console.log({ where: "driverManager > login > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
				driver.import(responseTAD.responseData[0].data);
				localStorage.setItem("sessionToken", responseTAD.responseData[0].tk);
				localStorage.setItem("lastUserName", driver.userName);
				driverManager.emit("loggedIn");

				break;
			case "ko":
				driverManager.emit("logInError", responseTAD.lastErrorMessage);
				break;
		}
	});
});

driverManager.addMethod("sessionCheck", function () {
	TADManager.clearCollection();
	TADManager.createTAD({ t: "driver", a: "sessionCheck"});

	TADManager.sendDefaultCollection(function (response) {
		var responseTAD = response.getItem(0);
		console.log({ where: "driverManager > sessionCheck > apiResponse", response: response, responseTAD: responseTAD });

		switch (responseTAD.checkResponseStatus()) {
			case "ok":
				//	Ste.Note: chiedere a Dave come risolvere il fatto di rinfrescare il currDriver se la sessione è ancora attiva
				Shark.set("currDriver", Shark.getInstance("Driver", responseTAD.responseData[0].data));
				driverManager.emit("sessionAlive");

				break;
			case "ko":
				driverManager.emit("sessionExpired", responseTAD.lastErrorMessage);
				break;
		}
	});
});

Shark.registerController(driverManager);

export { driverManager };